/**
 * Require input value to start with otherModel's value.
 * Error key: value-prefix
 * @example <input ng-model="foo" value-prefix="otherModel" />
 */
export default function /* @ngInject */ valuePrefix() {
    return {
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
            ngModel.$validators.value_prefix = function(value) {
                return value ? 0 === value.indexOf(attrs.valuePrefix) : true;
            };
        }
    };
}



// WEBPACK FOOTER //
// ./forms/validators/value-prefix.js